import React, { useState ,useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import infoLogo from "../../../assets/images/info.png";
import warningLogo from "../../../assets/images/warning.png";
import {FormattedMessage} from "react-intl";
import {Control, LocalForm, Errors} from "react-redux-form";

const ModalExample = (props) => {
  const {
    buttonLabel,
    className,
    size,
    warning,
    info,
    confirmation,
    isText,
    hasTitle,
    confirmation_dashboard,
    jdbcrow,
    changejdbsrow,
  } = props;

  const [modal, setModal] = useState(false);
  const [confirmdbpassword, setConfirmdbpassword] = useState("");


  const toggle = (val) => {
    setModal(!modal);
    console.log(modal)
    if(modal){
      console.log("exit!!")
      props.reset();
    }
  }

  const close = ()=>{
    toggle();
    if(props.hasOwnProperty('reset')){
      props.reset();
    }
    if(props.hasOwnProperty('message')){
      if(props.message && props.message.body.msg === "Token Expired"){
        console.log("Token Expired");
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/"
      }
    }
  }

  const closeConfrimation = ()=>{
    toggle();
    props.confirmationSub();
  }

  const longEnough = (val) => {console.log(val); val && val.length > 8};

  useEffect(() => {
    if(props.hasOwnProperty('setClick')){
      props.setClick(toggle);
    }
  }, []);

  return (
    <i>
      <Modal isOpen={modal} toggle={toggle} className={className} >
          <ModalHeader toggle={toggle}>
            <div style={{width: "372px"}}><img alt="SHIFT" src={infoLogo} className="modal_logo"/><i>JDBC Data Source</i> </div>
          </ModalHeader>
          <ModalBody style={{overflow: "auto", padding: "10px 40px"}}>
              <LocalForm
                model = "jdbc"
                className="form"
                onSubmit={()=>{close()}}
              >
                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    Name
                  </label>

                  <Control.text model="jdbc.driver"
                                value = {jdbcrow.name}
                                type="string"
                                readOnly
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    JDBC Driver
                  </label>

                  <Control.text model="jdbc.driver"
                                value = {jdbcrow.driver}
                                type="string"
                                readOnly
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    Host
                  </label>

                  <Control.text model=".host"
                                value = {jdbcrow.host}
                                onChange={(e)=>{let temp={...jdbcrow};temp.host=e.target.value;changejdbsrow(temp)}}
                                type="string"
                                required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    Port
                  </label>

                  <Control.text model="jdbcrow.port"
                                value = {jdbcrow.port}
                                onChange={(e)=>{let temp={...jdbcrow};temp.port=e.target.value;changejdbsrow(temp)}}
                                type="string"
                                required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    DB Name
                  </label>

                  <Control.text model="jdbcrow.dbname"
                                value = {jdbcrow.dbname}
                                onChange={(e)=>{let temp={...jdbcrow};temp.dbname=e.target.value;changejdbsrow(temp)}}
                                type="string"
                                required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    User Name
                  </label>

                  <Control.text model="jdbcrow.dbusername"
                                value = {jdbcrow.dbusername}
                                onChange={(e)=>{let temp={...jdbcrow};temp.dbusername=e.target.value;changejdbsrow(temp)}}
                                type="string"
                                required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    Password
                  </label>

                  <Control.text model="dbpassword"
                                value = {jdbcrow.dbpassword}
                                onChange={(e)=>{let temp={...jdbcrow};temp.dbpassword=e.target.value;changejdbsrow(temp)}}
                                type="password"
                                required
                  />
                </fieldset>

                <fieldset>
                  <label style={{ textTransform: 'capitalize' }}>
                    Confirm Password
                  </label>

                  <Control.text model=".confirmdbpassword"
                                value = {confirmdbpassword}
                                onChange={(e)=>{setConfirmdbpassword(e.target.value)}}
                                type="password"
                                validators={{
                                  endwith: val => {
                                    if(val === undefined){return confirmdbpassword === jdbcrow.dbpassword}
                                    else{
                                      return val===jdbcrow.dbpassword;
                                    }
                                  }
                                }}
                                required
                  />
                  <Errors
                    className="error"
                    style={{color : 'red'}}
                    model=".confirmdbpassword"
                    messages={{
                      endwith: 'Passwords do not match'
                    }}
                  />
                </fieldset>
                <br/>
                <br/>
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    style={{ marginRight : "20px"}}
                    type="button"
                    onClick={close}
                  >
                    CANCEL
                  </button>
                  <button
                    className="button"
                    type="submit"
                  >
                    SAVE
                  </button>
                </div>
              </LocalForm>
          </ModalBody>
        </Modal>
    </i>
  );
}

export default ModalExample;



// WEBPACK FOOTER //
// ./src/components/views/BuildCode/jdbcpopup.js